import { api } from '../api';
import SignUpEndpoints from './signUp.endpoints';
import {
  SignUpRequest,
  SignupPDVRequest,
  ValidateUsernameRequest,
} from './signUp.types';
import {
  TPromotionsResponseIType,
  transformPromotionsResponse,
} from './transformers/promotionsResponse';
import { transformSignUpErrorResponse } from './transformers/signUpErrorResponse';
import { EmailConfirmationRequest } from './validators/confirmEmailValidator';
import {
  signupPDVResponse,
  SignupPDVResponseIType,
} from './validators/signupPDVvalidator';
import { SignupResponse } from './validators/signupValidator';

const enhancedApi = api.injectEndpoints({
  endpoints: (build) => ({
    validateUsername: build.query<void, ValidateUsernameRequest>({
      query: (params) => ({
        url: SignUpEndpoints.ValidateUsername,
        params,
      }),
    }),
    signUp: build.mutation<SignupResponse, SignUpRequest>({
      query: (body) => ({
        url: SignUpEndpoints.SignUp,
        method: 'POST',
        body,
      }),
      transformErrorResponse: transformSignUpErrorResponse,
    }),
    signupPDV: build.query<SignupPDVResponseIType, SignupPDVRequest>({
      query: (params) => ({
        url: SignUpEndpoints.SignUpPDV,
        params,
      }),
      transformResponse: (response: SignupPDVResponseIType) => {
        signupPDVResponse.parse(response);
        return response;
      },
    }),
    confirmEmail: build.query<void, EmailConfirmationRequest>({
      query: (params) => ({
        url: SignUpEndpoints.ConfirmEmail,
        params,
      }),
    }),
    promotions: build.query<TPromotionsResponseIType, void>({
      query: () => ({
        url: SignUpEndpoints.WelcomeBonus,
      }),
      transformResponse: transformPromotionsResponse,
    }),
  }),
});

export const {
  useLazyValidateUsernameQuery,
  useSignUpMutation,
  useLazyConfirmEmailQuery,
  useLazySignupPDVQuery,
  usePromotionsQuery,
} = enhancedApi;
